// extracted by mini-css-extract-plugin
module.exports = {"cls1":"MainTransitionContainer-module--cls1--1zCFo","cls2":"MainTransitionContainer-module--cls2--1AcVR MainTransitionContainer-module--cls1--1zCFo"};